import React from 'react';
import { Table, Row, Col, Button, Dropdown, List, Pagination } from 'antd';
import { InfoCircleOutlined,  SettingOutlined, DownCircleOutlined, CheckCircleOutlined, DownloadOutlined, WhatsAppOutlined, QrcodeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import { getParamTable, _tableLogActivity } from '../../../../lib/Helper';

class Desktop extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    };
  }

  componentDidMount() {
    this.props.fetchTable()
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={[
                {
                  title: 'No',
                  dataIndex: 'rownum',
                  sorter: false,
                  width: '2%',
                },
                {
                  title: 'No.KTA',
                  dataIndex: 'no_kta',
                  sorter: false,
                },
                {
                  title: 'Nama Alumni',
                  dataIndex: 'nama',
                  sorter: false,
                },
                {
                  title: 'Jenis Kelamin',
                  dataIndex: 'jenis_kelamin',
                  sorter: false,
                },
                {
                  title: 'Tempat/Tgl Lahir',
                  dataIndex: 'ttl',
                  sorter: false,
                  render: (a, row) => <List.Item style={{ padding: 0 }}>
                    <List.Item.Meta
                      title={row.tempat_lahir}
                      description={<small>{row.tgl_lahir}</small>}
                    />
                  </List.Item>,
                },
                {
                  title: 'Tahun Lulus',
                  dataIndex: 'tahun_lulus',
                  sorter: false,
                },
                {
                  title: 'Tipe Alumni',
                  dataIndex: 'alumni_tipe',
                  sorter: false,
                },
                {
                  title: 'Status',
                  dataIndex: 'alumni_verifikasi',
                  sorter: false,
                },
                // {
                //   title: 'KTA',
                //   dataIndex: 'file',
                //   render: (a, row) => <a target="_blank" rel="noopener noreferrer" href={row.main_path + row.file} style={{ fontSize: 11 }}>Download <DownloadOutlined/></a>,
                // },
                {
                  title: <SettingOutlined />,
                  align: "center",
                  key: 'operation',
                  width: '2%',
                  render: (a, row) => <Dropdown trigger={['click']} menu={{
  items: [...(action.detail === true ? [{
    key: 0,
    label: <Link to={"/peserta-didik/alumni/detail/" + (row.alumni_tipe === "Alumni Eksternal" ? "external" : "internal") + "/" + row.id}><InfoCircleOutlined /> Detail</Link>
  }] : []), ...(action.verification === true && row.alumni_verifikasi === "Belum Diverifikasi" ? [{
    key: 1,
    icon: <CheckCircleOutlined />,
    label: "Verifikasi Data",
    onClick: this.props.modalVerification.bind(this, true, row)
  }] : []), {
    key: 2,
    icon: <DownloadOutlined />,
    label: "Preview KTA",
    onClick: this.props.modalPreviewKTA.bind(this, true, row)
  }, {
    key: 3,
    icon: <WhatsAppOutlined />,
    label: "Kirim Whatsapp",
    onClick: this.props.modalSendWa.bind(this, true, row)
  }, {
    key: 4,
    icon: <QrcodeOutlined />,
    label: "Generate QrCode",
    onClick: this.props.modalQrCode.bind(this, true, row)
  }]
}}>
                    <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                  </Dropdown>,
                },
                {
                  title: 'LogActivity',
                  key: 'operation',
                  width: '10%',
                  render: (a, row) => _tableLogActivity(row),
                },
              ]}
              rowKey={record => record.id}
              dataSource={table.data}
              pagination={false}
              loading={table.loading}
              size="small"
            />
          </Col>
          <Col xs={24} className="table-pagination">
            <Pagination
              size="small"
              current={table.pagination.current}
              pageSize={table.pagination.pageSize}
              total={table.pagination.total}
              showTotal={() => `Total ${table.pagination.total} items`}
              showSizeChanger
              onChange={(current, pageSize) => {
                const pagination = { current: current, pageSize: pageSize, total: table.pagination.total }
                const params = getParamTable("change", table, null, null, pagination)
                this.props.fetch(params)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }
}

export default Desktop;
